/**
 * Shared MITO type scale.
 *
 * Audit of Trust (Aug 2026): pages mixed SF Pro headings with Source Sans /
 * system-font body, plus 10 / 11 / 12 / 13 / 14 / 15 / 16 / 18 / 20 / 24 px.
 * Locked roles:
 *   caption / label / helper / error / breadcrumb  12px  xs | sm
 *   body / secondary copy                          14px  md
 *   inputs / buttons / nav                         16px  lg
 *   section title                                  18px  xl
 *   card title                                     20px  xxl
 *   page title                                     24px  xxxl
 *   hero                                           32–60 Enlarge / Laptop*
 */
export const MITO_FONT =
  'SFProDisplay, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif';

export const mitoFonts = {
  heading: MITO_FONT,
  body: MITO_FONT,
};

export const mitoFontSizes = {
  xs: "12px",
  sm: "12px",
  md: "14px",
  lg: "16px",
  xl: "18px",
  xxl: "20px",
  xxxl: "24px",
  Enlarge: "32px",
  LaptopFontMd: "40px",
  LaptopFont: "60px",
  Banner: "70px",
};

export const mitoText = {
  baseStyle: {
    fontFamily: "body",
    fontSize: "md",
    lineHeight: "20px",
    color: "black.200",
  },
};

export const mitoFormLabel = {
  baseStyle: {
    fontFamily: "body",
    fontSize: "sm",
    fontWeight: "medium",
    lineHeight: "16px",
    color: "black.100",
    mb: "6px",
  },
};

export const MITO_ORANGE = "#FB4B14";
export const MITO_ORANGE_HOVER = "#E04312";
export const MITO_BLUE = "#2E5BFF";
export const MITO_BLUE_HOVER = "#2448CC";

/** All / Unread and other short filter chips. Same box on orange and blue. */
export const mitoFilterPill = {
  minW: "96px",
  w: "96px",
  h: "36px",
  px: "12px",
  borderRadius: "full",
} as const;

export type MitoThemeName = "orange" | "blue";

export const mitoPalettes: Record<
  MitoThemeName,
  { primary: string; hover: string; className: string }
> = {
  orange: {
    primary: MITO_ORANGE,
    hover: MITO_ORANGE_HOVER,
    className: "mito-theme-orange",
  },
  blue: {
    primary: MITO_BLUE,
    hover: MITO_BLUE_HOVER,
    className: "mito-theme-blue",
  },
};
